/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Group_MonthInputs */

const vi_warehouse_sales_group_month = /** @type {(inputs: Warehouse_Sales_Group_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tháng`)
};

/**

* @param {Warehouse_Sales_Group_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_group_month = /** @type {((inputs?: Warehouse_Sales_Group_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Group_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_group_month(inputs)
});